import { r as registerInstance, h, H as Host } from './core-a69618da.js';
var Placeholder = /** @class */ (function () {
    function class_1(hostRef) {
        registerInstance(this, hostRef);
    }
    class_1.prototype.render = function () {
        return (h("section", { class: 'placeholder' }, h("div", { class: 'progress' }, h("div", { class: 'progress__animation' })), h("div", { class: 'placeholder__title' }, h("slot", { name: 'header' }, "Loading data...")), h("div", { class: 'placeholder__content' }, h("slot", null))));
    };
    Object.defineProperty(class_1, "style", {
        get: function () { return ".placeholder{position:relative;background-color:var(--as--color--ui-01,#fff)}.placeholder__title{margin-bottom:8px;font:var(--as--font--body,12px/20px var(--as--font-family--base))}.progress{position:absolute;top:0;left:0;width:100%;height:2px;overflow:hidden}.progress__animation{position:absolute;width:40%;height:3px;-webkit-transform:translateX(-300%);transform:translateX(-300%);-webkit-animation:loader-progress 1s cubic-bezier(0,.85,.6,.6) infinite;animation:loader-progress 1s cubic-bezier(0,.85,.6,.6) infinite;background-color:var(--as--color--primary,#1785fb)}\@-webkit-keyframes loader-progress{0%{-webkit-transform:translateX(-300%);transform:translateX(-300%)}to{-webkit-transform:translateX(300%);transform:translateX(300%)}}\@keyframes loader-progress{0%{-webkit-transform:translateX(-300%);transform:translateX(-300%)}to{-webkit-transform:translateX(300%);transform:translateX(300%)}}"; },
        enumerable: true,
        configurable: true
    });
    return class_1;
}());
var PlaceholderBar = /** @class */ (function () {
    function class_2(hostRef) {
        registerInstance(this, hostRef);
    }
    class_2.prototype.render = function () {
        var styles = {
            height: this.height,
            width: this.width
        };
        return (h(Host, { style: styles }, h("div", { class: 'placeholder-bar' })));
    };
    Object.defineProperty(class_2, "style", {
        get: function () { return "as-placeholder-bar{display:block;max-width:100%}.placeholder-bar{height:100%;background-color:var(--as--color--ui-02,#f5f5f5)}"; },
        enumerable: true,
        configurable: true
    });
    return class_2;
}());
export { Placeholder as as_placeholder, PlaceholderBar as as_placeholder_bar };
